import BaseModel from "./BaseModel";
import Document from "./Document";

export default class DocumentAttachment extends BaseModel {

	static entity = 'document_attachments';
	static route = 'document-attachments';
	static plural = 'document_attachments';
	static singular = 'document_attachment';

	static fields () {
		return {
			id: this.attr(null),
			document_id: this.attr(null),
			document: this.belongsTo(Document, 'document_id'),
			model_type: this.attr(null),
			model_id: this.attr(null),
			ref: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
		}
	}

}
